// import { AccountantBankSetup } from "components/AccountantBank";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { AccountantBankSetup } from "../../../components/Accountant/AccountantBankSetup/AccountantBankSetup";

export const AccountantBankSetupPage = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Accountant Bank Setup"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[
				// { text: "accountants", navigateTo: "/accountants/list" },
				{ text: "Accountant Bank Setup", navigateTo: "/accountants/bank-setup" },
			]}
			mainContents={<AccountantBankSetup />}
		/>
	);
};
